export function generateId() {
  return '_' + Math.random().toString(36).substr(2, 9)
}

export const normalizingSignee = signer => {
  let prev = {}

  signer?.forEach((item, index) => {
    const id = item.recipient_id
    const current = {
      [id]: {
        color: item.metadata.is_creator ? '#70AAFF' : item.metadata.color || '#F7D250',
        dob: item.dob || null,
        email: item.email,
        filled: item.metadata.filled,
        first_name: item.first_name,
        id: id,
        last_name: item.last_name,
        phone_number: item.phone_number,
        role: null,
        selected: item.metadata.is_creator ? true : false,
        recipient_signing_status: item.recipient_signing_status,
        signer_id: item.id,
        user_id: item.user_id,
        recipient_id: item.recipient_id,
        signed_at: item.signed_at
      }
    }
    Object.assign(prev, current)
  })
  return prev
}
